import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { fetchChallenges } from 'src/actions/mine_craft/challengesActions';
import { queryParams } from "src/helpers/UrlHelpers";

import PageHeader from './_partials/_PageHeader';
import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";
import Edit from "./Edit";
import New from "./New";
import Wrapper from "src/componets/Wrapper";
import NavBarThree from "src/componets/NavBarThree";
import Filter from "src/componets/Filter";
import './style.scss';
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "src/store/mine_craft/challengesSlice";
import MenuTypes from "./_partials/_MenuTypes";

const LIMIT = 42;
const STATE: any = {
  'all': {
    name: 'All'
  },
  'active': {
    name: 'Active'
  },
  'ended': {
    name: 'Ended'
  },
  'upcoming': {
    name: 'Upcoming'
  },
  'past_week': {
    name: 'Past week'
  }
};
const STATE_IDS = Object.keys(STATE);

export interface PropsInterface {
  appId: 1 | 2;
}

const Challenges = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const typeId = queryParams.get(searchParams,'add_type');
  const stateId = queryParams.get(searchParams,'state');
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();
  const orderByFilter = {
    items: [
      { name: 'Created at', key: 'id' },
      { name: 'Post counts', key: 'addons_count' },
      { name: 'Start at', key: 'start_at' },
      { name: 'End at', key: 'end_at' },
    ]
  };

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (typeId) {
      params.add_type = typeId;
    }

    if (stateId) {
      params.state = stateId;
    }

    dispatch(fetchChallenges(params));
  }, [searchParams, stateId, appId, pathname, typeId, currentPage, dispatch]);

  const isActive = (id: string | undefined) => {
    return (!stateId && id === 'all') || stateId === id ? 'active' : '';
  }

  const renderFilterItem = (id: any) => {
    const item = STATE[id];
    const queryParams = id === 'all' ? '' : `?state=${id}`;

    return (
      <NavBarThree.Link
        key={id}
        className={isActive(id)}
        to={queryParams}
      >
        {item.name}
      </NavBarThree.Link>
    )
  }

  function onClickCreate() {
    const params: any = { app_id: appId };

    if (typeId) {
      params.add_type = typeId.split(',')[0];
    }

    dispatch(setNewParams(params));
  }

  return (
    <PageLayout>
      <PageHeader />

      <Wrapper className='v-wrapper__between'>
        <NavBarThree type='type1'>
          {STATE_IDS.map(renderFilterItem)}
        </NavBarThree>

        <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
          <PlusOutlined /> Create Challenge
        </NavBarThree.Button>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={orderByFilter}
          >
            <MenuTypes />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} />
      </div>

      <Edit />
      <New />
    </PageLayout>
  );
}

export default Challenges;
